import { ActionableItemDisplay } from './ActionableItemDisplay';
import { disableChild } from '../../../../utils/disableChildUtil';
import { ActionableItemLoader } from './ActionableItemLoader';
import { buildAccessCheckTooltipTitle } from '../../../../utils/buildAccessCheckTooltipTitle';
import { jsx as _jsx } from "react/jsx-runtime";
export function ActionableItemDisplayWrapper({
  accessInfo,
  contentOverride,
  taskDescription,
  requestAccessConfig,
  loadingComponent,
  children,
  tooltipProps
}) {
  if (accessInfo.hasAccess) {
    return children;
  }
  if (!accessInfo.isVisible) {
    return null;
  }
  if (accessInfo.isLoading) {
    return /*#__PURE__*/_jsx(ActionableItemLoader, {
      loadingComponent: loadingComponent,
      children: children
    });
  }
  const title = buildAccessCheckTooltipTitle(accessInfo, taskDescription, contentOverride);
  return /*#__PURE__*/_jsx(ActionableItemDisplay, {
    requestAccessConfig: requestAccessConfig,
    taskDescription: taskDescription,
    title: title,
    tooltipProps: tooltipProps,
    children: disableChild(children)
  });
}